import _defineProperty from "D:/VUE\u5EB7\u4E50\u901A\u95E8\u5E97/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "D:/VUE\u5EB7\u4E50\u901A\u95E8\u5E97/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  key: 0,
  "class": "tui-search-result-main"
};
var _hoisted_2 = {
  "class": "tui-search-result-list"
};
var _hoisted_3 = {
  "class": "tui-search-result-list-item"
};
var _hoisted_4 = {
  key: 0,
  "class": "header"
};
var _hoisted_5 = {
  "class": "list"
};
var _hoisted_6 = ["onClick"];
var _hoisted_7 = {
  "class": "more-text"
};
var _hoisted_8 = {
  key: 1,
  "class": "tui-search-message-header"
};
var _hoisted_9 = {
  "class": "header-content"
};
var _hoisted_10 = {
  "class": "header-content-count normal"
};
var _hoisted_11 = {
  "class": "header-content-keyword"
};
var _hoisted_12 = {
  "class": "highlight"
};
var _hoisted_13 = {
  "class": "header-content-type normal"
};
var _hoisted_14 = {
  key: 2,
  "class": "tui-search-message-list"
};
var _hoisted_15 = {
  "class": /*@__PURE__*/_normalizeClass(['list-group-date'])
};
var _hoisted_16 = {
  "class": "more-text"
};
import { TUITranslateService, TUIConversationService, TUIStore, StoreName } from "@tencentcloud/chat-uikit-engine";
import SearchResultItem from "./search-result-item/index.vue";
import SearchResultDefault from "./search-result-default/index.vue";
import SearchResultLoading from "./search-result-loading/index.vue";
import { searchMessageTypeList, searchMessageTypeDefault } from "../search-type-list";
import Icon from "../../common/Icon.vue";
import searchIcon from "../../../assets/icon/search.svg";
import enterIcon from "../../../assets/icon/right-icon.svg";
import { ref, watch, computed } from "../../../adapter-vue";
import { searchCloudMessages, enterConversation, generateSearchResultYMD, debounce } from "../utils";
import { isPC } from "../../../utils/env";
import { enableSampleTaskStatus } from "../../../utils/enableSampleTaskStatus";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    searchType: {
      type: String,
      "default": "global",
      validator: function validator(value) {
        return ["global", "conversation"].includes(value);
      }
    }
  },
  setup: function setup(__props) {
    var _searchMessageTypeDef, _searchMessageTypeDef2;
    var props = __props;
    // search params
    var keywordList = ref([]);
    var messageTypeList = ref((_searchMessageTypeDef = searchMessageTypeDefault[props.searchType]) === null || _searchMessageTypeDef === void 0 ? void 0 : _searchMessageTypeDef.value);
    var timePosition = ref(0);
    var timePeriod = ref(0);
    // 通过空格分割整串输入后，按照“与”关系搜索
    // 比如: 输入"111 222", 搜索既有 111 又有 222 的消息, 同时也包含到严格搜索“111 222”的消息情况
    var keywordListMatchType = ref("and");
    // current search tab key
    var currentSearchTabKey = ref((_searchMessageTypeDef2 = searchMessageTypeDefault[props.searchType]) === null || _searchMessageTypeDef2 === void 0 ? void 0 : _searchMessageTypeDef2.key);
    // search results all（所有会话搜索结果)
    var searchResult = ref({});
    var searchAllMessageList = ref([]);
    var searchAllMessageTotalCount = ref(0);
    var searchFriendList = ref([]);
    var searchGroupList = ref([]);
    // search results detail（具体某个会话的搜索结果）
    var currentSearchConversationID = ref("");
    var searchConversationResult = ref();
    var searchConversationMessageList = ref([]);
    var searchConversationMessageTotalCount = ref();
    // 文件消息/图片视频消息的搜索结果，按时间线分组
    var searchConversationResultGroupByDate = ref([]);
    // ui display control
    var isResultDetailShow = ref(false);
    var isLoading = ref(false);
    var isSearchDetailLoading = ref(false);
    var isSearchDefaultShow = computed(function () {
      if (isLoading.value) {
        return false;
      }
      if (props.searchType === "global") {
        var _keywordList$value, _Object$keys;
        // 未搜索 / 有结果
        if (!(keywordList !== null && keywordList !== void 0 && (_keywordList$value = keywordList.value) !== null && _keywordList$value !== void 0 && _keywordList$value.length) || Object !== null && Object !== void 0 && (_Object$keys = Object.keys(searchResult.value)) !== null && _Object$keys !== void 0 && _Object$keys.length) {
          return false;
        } else {
          return true;
        }
      } else {
        var _searchConversationMe;
        if (searchConversationMessageList !== null && searchConversationMessageList !== void 0 && (_searchConversationMe = searchConversationMessageList.value) !== null && _searchConversationMe !== void 0 && _searchConversationMe.length) {
          return false;
        } else {
          return true;
        }
      }
    });
    TUIStore.watch(StoreName.CONV, {
      currentConversationID: function currentConversationID(id) {
        props.searchType === "conversation" && (currentSearchConversationID.value = id);
      }
    });
    TUIStore.watch(StoreName.CUSTOM, {
      currentSearchInputValue: function currentSearchInputValue(obj) {
        if ((obj === null || obj === void 0 ? void 0 : obj.searchType) === (props === null || props === void 0 ? void 0 : props.searchType)) {
          // 根据空格模糊搜索结果
          keywordList.value = obj !== null && obj !== void 0 && obj.value ? obj.value.trim().split(/\s+/) : [];
        }
      },
      currentSearchMessageType: function currentSearchMessageType(typeObject) {
        if ((typeObject === null || typeObject === void 0 ? void 0 : typeObject.searchType) === (props === null || props === void 0 ? void 0 : props.searchType)) {
          var _typeObject$value, _searchMessageTypeDef3, _typeObject$value2, _searchMessageTypeDef4;
          currentSearchTabKey.value = (typeObject === null || typeObject === void 0 || (_typeObject$value = typeObject.value) === null || _typeObject$value === void 0 ? void 0 : _typeObject$value.key) || ((_searchMessageTypeDef3 = searchMessageTypeDefault[props.searchType]) === null || _searchMessageTypeDef3 === void 0 ? void 0 : _searchMessageTypeDef3.key);
          messageTypeList.value = (typeObject === null || typeObject === void 0 || (_typeObject$value2 = typeObject.value) === null || _typeObject$value2 === void 0 ? void 0 : _typeObject$value2.value) || ((_searchMessageTypeDef4 = searchMessageTypeDefault[props.searchType]) === null || _searchMessageTypeDef4 === void 0 ? void 0 : _searchMessageTypeDef4.value);
        }
      },
      currentSearchMessageTime: function currentSearchMessageTime(timeObject) {
        if ((timeObject === null || timeObject === void 0 ? void 0 : timeObject.searchType) === (props === null || props === void 0 ? void 0 : props.searchType)) {
          var _timeObject$value, _timeObject$value2;
          timePosition.value = timeObject === null || timeObject === void 0 || (_timeObject$value = timeObject.value) === null || _timeObject$value === void 0 || (_timeObject$value = _timeObject$value.value) === null || _timeObject$value === void 0 ? void 0 : _timeObject$value.timePosition;
          timePeriod.value = timeObject === null || timeObject === void 0 || (_timeObject$value2 = timeObject.value) === null || _timeObject$value2 === void 0 || (_timeObject$value2 = _timeObject$value2.value) === null || _timeObject$value2 === void 0 ? void 0 : _timeObject$value2.timePeriod;
        }
      }
    });
    var setMessageSearchResultList = function setMessageSearchResultList(option) {
      var _keywordList$value2;
      searchCloudMessages({
        keywordList: keywordList !== null && keywordList !== void 0 && (_keywordList$value2 = keywordList.value) !== null && _keywordList$value2 !== void 0 && _keywordList$value2.length ? keywordList.value : undefined,
        messageTypeList: messageTypeList.value,
        timePosition: timePosition.value,
        timePeriod: timePeriod.value,
        conversationID: (option === null || option === void 0 ? void 0 : option.conversationID) || undefined,
        cursor: (option === null || option === void 0 ? void 0 : option.cursor) || undefined,
        keywordListMatchType: keywordListMatchType.value
      }).then(function (res) {
        enableSampleTaskStatus("searchCloudMessage");
        if (!(option !== null && option !== void 0 && option.conversationID)) {
          var _res$data, _res$data2, _res$data3, _searchAllMessageList;
          // 全部会话搜索结果
          option !== null && option !== void 0 && option.cursor ? searchAllMessageList.value = [].concat(_toConsumableArray(searchAllMessageList.value), _toConsumableArray(res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.searchResultList)) : searchAllMessageList.value = res === null || res === void 0 || (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.searchResultList;
          searchAllMessageTotalCount.value = res === null || res === void 0 || (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.totalCount;
          var key = currentSearchTabKey.value === "all" ? "allMessage" : currentSearchTabKey.value;
          if (searchAllMessageList !== null && searchAllMessageList !== void 0 && (_searchAllMessageList = searchAllMessageList.value) !== null && _searchAllMessageList !== void 0 && _searchAllMessageList.length && currentSearchTabKey.value !== "contact" && currentSearchTabKey.value !== "group") {
            var _searchAllMessageList2, _res$data4;
            searchResult.value = Object.assign({}, searchResult.value, _defineProperty({}, key, {
              key: key,
              label: searchMessageTypeList[key].label,
              list: currentSearchTabKey.value === "all" ? searchAllMessageList === null || searchAllMessageList === void 0 || (_searchAllMessageList2 = searchAllMessageList.value) === null || _searchAllMessageList2 === void 0 ? void 0 : _searchAllMessageList2.slice(0, 3) : searchAllMessageList === null || searchAllMessageList === void 0 ? void 0 : searchAllMessageList.value,
              cursor: (res === null || res === void 0 || (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.cursor) || null
            }));
          } else {
            searchResult === null || searchResult === void 0 || delete searchResult.value[key];
          }
        } else {
          var _res$data5, _res$data6, _res$data7;
          // 指定会话搜索结果
          searchConversationResult.value = res === null || res === void 0 ? void 0 : res.data;
          option !== null && option !== void 0 && option.cursor ? searchConversationMessageList.value = [].concat(_toConsumableArray(searchConversationMessageList.value), _toConsumableArray(res === null || res === void 0 || (_res$data5 = res.data) === null || _res$data5 === void 0 || (_res$data5 = _res$data5.searchResultList[0]) === null || _res$data5 === void 0 ? void 0 : _res$data5.messageList)) : searchConversationMessageList.value = res === null || res === void 0 || (_res$data6 = res.data) === null || _res$data6 === void 0 || (_res$data6 = _res$data6.searchResultList[0]) === null || _res$data6 === void 0 ? void 0 : _res$data6.messageList;
          searchConversationMessageTotalCount.value = res === null || res === void 0 || (_res$data7 = res.data) === null || _res$data7 === void 0 ? void 0 : _res$data7.totalCount;
          // 计算时间戳展示位置（仅会话内搜索 文件/图片 类型需要）
          if ((props === null || props === void 0 ? void 0 : props.searchType) === "conversation" && (currentSearchTabKey.value === "fileMessage" || currentSearchTabKey.value === "imageMessage")) {
            searchConversationResultGroupByDate.value = groupResultListByDate(searchConversationMessageList.value);
          } else {
            searchConversationResultGroupByDate.value = [];
          }
        }
        isLoading.value = false;
        isSearchDetailLoading.value = false;
      });
    };
    var setMessageSearchResultListDebounce = debounce(setMessageSearchResultList, 500);
    var resetSearchResult = function resetSearchResult() {
      searchResult.value = {};
      searchConversationResult.value = {};
      searchConversationMessageList.value = [];
      searchConversationResultGroupByDate.value = [];
    };
    watch(function () {
      return [keywordList.value, currentSearchTabKey.value, timePosition.value, timePeriod.value];
    }, function (newValue, oldValue) {
      var _keywordList$value3;
      if (newValue === oldValue) {
        return;
      }
      // 全局搜索必须有关键词，会话内搜索可以没有关键词
      if (!(keywordList !== null && keywordList !== void 0 && (_keywordList$value3 = keywordList.value) !== null && _keywordList$value3 !== void 0 && _keywordList$value3.length) && (props === null || props === void 0 ? void 0 : props.searchType) === "global") {
        resetSearchResult();
        return;
      }
      isLoading.value = true;
      if (props.searchType === "conversation") {
        // 会话内搜索
        resetSearchResult();
        setMessageSearchResultList({
          conversationID: currentSearchConversationID.value
        });
      } else {
        // 全局搜索
        if (oldValue && oldValue[1] === "all" && newValue && newValue[1] === "allMessage") {
          var _searchResult$value$a, _Object$keys2;
          // 从【全部结果-聊天记录】分类中 点击某条结果，直接跳转到【聊天记录】tab，并且打开相关会话内搜索结果 情况, isResultDetailShow 保持为true
          // 不重新搜索
          (searchResult === null || searchResult === void 0 || (_searchResult$value$a = searchResult.value["allMessage"]) === null || _searchResult$value$a === void 0 ? void 0 : _searchResult$value$a.list) && (searchResult.value["allMessage"].list = searchAllMessageList === null || searchAllMessageList === void 0 ? void 0 : searchAllMessageList.value);
          // 清除非聊天记录类型的其他搜索结果
          Object === null || Object === void 0 || (_Object$keys2 = Object.keys(searchResult === null || searchResult === void 0 ? void 0 : searchResult.value)) === null || _Object$keys2 === void 0 || _Object$keys2.forEach(function (key) {
            if (key !== "allMessage") {
              searchResult === null || searchResult === void 0 || delete searchResult.value[key];
            }
          });
          isLoading.value = false;
          return;
        } else {
          // 其余情况，恢复 isResultDetailShow.value 为 false，并且重新搜索
          isResultDetailShow.value = false;
          resetSearchResult();
        }
        setMessageSearchResultListDebounce();
      }
    }, {
      immediate: true
    });
    var getMoreResult = function getMoreResult(result) {
      if (currentSearchTabKey.value === "all") {
        // 此时查看更多：切换到相应结果对应的result，展示其类型全量搜索结果
        TUIStore.update(StoreName.CUSTOM, "currentSearchMessageType", {
          value: searchMessageTypeList[result.key],
          searchType: props.searchType
        });
      } else {
        // 在某一单类结果下查看更多：根据 cursor 作为搜索起始位置，拉取下一部分结果
        setMessageSearchResultList({
          cursor: result === null || result === void 0 ? void 0 : result.cursor
        });
      }
    };
    var getMoreResultInConversation = function getMoreResultInConversation() {
      var _searchConversationRe;
      setMessageSearchResultList({
        cursor: searchConversationResult === null || searchConversationResult === void 0 || (_searchConversationRe = searchConversationResult.value) === null || _searchConversationRe === void 0 ? void 0 : _searchConversationRe.cursor,
        conversationID: currentSearchConversationID === null || currentSearchConversationID === void 0 ? void 0 : currentSearchConversationID.value
      });
    };
    var showResultDetail = function showResultDetail(isShow, targetType, targetResult) {
      var _targetResult$convers;
      isResultDetailShow.value = isShow;
      if (targetType) {
        TUIStore.update(StoreName.CUSTOM, "currentSearchMessageType", {
          value: searchMessageTypeList[targetType],
          searchType: props.searchType
        });
      }
      currentSearchConversationID.value = targetResult === null || targetResult === void 0 || (_targetResult$convers = targetResult.conversation) === null || _targetResult$convers === void 0 ? void 0 : _targetResult$convers.conversationID;
      searchConversationMessageTotalCount.value = targetResult === null || targetResult === void 0 ? void 0 : targetResult.messageCount;
      if (targetResult) {
        isSearchDetailLoading.value = true;
        setMessageSearchResultListDebounce({
          conversationID: currentSearchConversationID.value
        });
      }
    };
    var generateListItemClass = function generateListItemClass(item) {
      var _item$conversation;
      return currentSearchConversationID.value === (item === null || item === void 0 || (_item$conversation = item.conversation) === null || _item$conversation === void 0 ? void 0 : _item$conversation.conversationID) ? ["list-item", "list-item-selected"] : ["list-item"];
    };
    var generateResultItemDisplayType = function generateResultItemDisplayType() {
      if (props.searchType === "conversation" && currentSearchTabKey.value === "fileMessage") {
        return "file";
      } else if (props.searchType === "conversation" && currentSearchTabKey.value === "imageMessage") {
        return "image";
      } else if (isPC) {
        return "bubble";
      } else {
        return "info";
      }
    };
    var groupResultListByDate = function groupResultListByDate(messageList) {
      var result = [];
      if (!(messageList !== null && messageList !== void 0 && messageList.length)) {
        return result;
      } else if ((messageList === null || messageList === void 0 ? void 0 : messageList.length) === 1) {
        var _messageList$;
        result.push({
          date: generateSearchResultYMD((_messageList$ = messageList[0]) === null || _messageList$ === void 0 ? void 0 : _messageList$.time),
          list: messageList
        });
        return result;
      }
      var prevYMD = "";
      var currYMD = "";
      for (var i = 0; i < (messageList === null || messageList === void 0 ? void 0 : messageList.length); i++) {
        var _messageList$i;
        currYMD = generateSearchResultYMD((_messageList$i = messageList[i]) === null || _messageList$i === void 0 ? void 0 : _messageList$i.time);
        if (prevYMD !== currYMD) {
          result.push({
            date: currYMD,
            list: [messageList[i]]
          });
        } else {
          var _result;
          (_result = result[(result === null || result === void 0 ? void 0 : result.length) - 1]) === null || _result === void 0 || (_result = _result.list) === null || _result === void 0 || _result.push(messageList[i]);
        }
        prevYMD = currYMD;
      }
      return result;
    };
    var navigateToChatPosition = function navigateToChatPosition(message) {
      if (props.searchType === "global") {
        // 全局搜索，关闭 search container
        TUIStore.update(StoreName.CUSTOM, "currentSearchingStatus", {
          isSearching: false,
          searchType: props.searchType
        });
        // 切换会话
        TUIConversationService.switchConversation(message === null || message === void 0 ? void 0 : message.conversationID).then(function () {
          TUIStore.update(StoreName.CHAT, "messageSource", message);
        });
      } else if (props.searchType === "conversation") {
        // 会话内搜索，关闭 search container
        TUIStore.update(StoreName.CUSTOM, "isShowInConversationSearch", false);
        TUIStore.update(StoreName.CHAT, "messageSource", message);
      }
    };
    var generateVueRenderKey = function generateVueRenderKey(value) {
      return "".concat(currentSearchTabKey, "-").concat(value);
    };
    return function (_ctx, _cache) {
      return _unref(isLoading) ? (_openBlock(), _createBlock(SearchResultLoading, {
        key: 0
      })) : _unref(isSearchDefaultShow) ? (_openBlock(), _createBlock(SearchResultDefault, {
        key: 1
      })) : (_openBlock(), _createElementBlock("div", {
        key: 2,
        "class": _normalizeClass(['tui-search-result', !_unref(isPC) && 'tui-search-result-h5', _unref(isPC) && _unref(isResultDetailShow) && 'tui-search-result-with-border'])
      }, [props.searchType !== 'conversation' && (_unref(isPC) || !_unref(isResultDetailShow)) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchResult), function (result) {
        return _openBlock(), _createElementBlock("div", _hoisted_3, [props.searchType === 'global' ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(TUITranslateService).t("TUISearch.".concat(result.label))), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(result.list, function (item) {
          return _openBlock(), _createElementBlock("div", {
            "class": _normalizeClass([generateListItemClass(item)])
          }, [result.key === 'contact' || result.key === 'group' || item.conversation ? (_openBlock(), _createBlock(SearchResultItem, {
            key: 0,
            listItem: item,
            type: result.key,
            displayType: "info",
            keywordList: _unref(keywordList),
            onShowResultDetail: showResultDetail,
            onNavigateToChatPosition: navigateToChatPosition
          }, null, 8, ["listItem", "type", "keywordList"])) : _createCommentVNode("", true)], 2);
        }), 256))]), _unref(currentSearchTabKey) === 'all' || result.cursor ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          "class": "more",
          onClick: function onClick($event) {
            return getMoreResult(result);
          }
        }, [_createVNode(Icon, {
          "class": "more-icon",
          file: _unref(searchIcon),
          width: "12px",
          height: "12px"
        }, null, 8, ["file"]), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, _toDisplayString(_unref(TUITranslateService).t("TUISearch.查看更多")), 1), _createElementVNode("span", null, _toDisplayString(_unref(TUITranslateService).t("TUISearch.".concat(result.label))), 1)])], 8, _hoisted_6)) : _createCommentVNode("", true)]);
      }), 256))])])) : _createCommentVNode("", true), _unref(isResultDetailShow) || props.searchType === 'conversation' ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        "class": _normalizeClass(['tui-search-result-detail', props.searchType === 'conversation' && 'tui-search-result-in-conversation'])
      }, [_unref(isSearchDetailLoading) ? (_openBlock(), _createBlock(SearchResultLoading, {
        key: 0
      })) : _createCommentVNode("", true), !_unref(isSearchDetailLoading) && _unref(isResultDetailShow) && props.searchType !== 'conversation' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("span", null, _toDisplayString(_unref(searchConversationMessageTotalCount)), 1), _createElementVNode("span", null, _toDisplayString(_unref(TUITranslateService).t("TUISearch.条与")), 1)]), _createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(keywordList), function (keyword, index) {
        return _openBlock(), _createElementBlock("span", {
          key: index
        }, [_cache[1] || (_cache[1] = _createElementVNode("span", {
          "class": "normal"
        }, "\"", -1)), _createElementVNode("span", _hoisted_12, _toDisplayString(keyword), 1), _cache[2] || (_cache[2] = _createElementVNode("span", {
          "class": "normal"
        }, "\"", -1))]);
      }), 128))]), _createElementVNode("div", _hoisted_13, [_createElementVNode("span", null, _toDisplayString(_unref(TUITranslateService).t("TUISearch.相关的")), 1), _createElementVNode("span", null, _toDisplayString(_unref(TUITranslateService).t("TUISearch.".concat(_unref(currentSearchTabKey) === "allMessage" ? "结果" : _unref(searchMessageTypeList)[_unref(currentSearchTabKey)].label))), 1)])]), _createElementVNode("div", {
        "class": "header-enter",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return _unref(enterConversation)({
            conversationID: _unref(currentSearchConversationID)
          });
        })
      }, [_createElementVNode("span", null, _toDisplayString(_unref(TUITranslateService).t("TUISearch.进入聊天")), 1), _createVNode(Icon, {
        "class": "enter-icon",
        file: _unref(enterIcon),
        width: "14px",
        height: "14px"
      }, null, 8, ["file"])])])) : _createCommentVNode("", true), !_unref(isSearchDetailLoading) && _unref(searchConversationMessageList) && _unref(searchConversationMessageList)[0] ? (_openBlock(), _createElementBlock("div", _hoisted_14, [props.searchType === 'global' || _unref(currentSearchTabKey) !== 'imageMessage' && _unref(currentSearchTabKey) !== 'fileMessage' ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(_unref(searchConversationMessageList), function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          "class": _normalizeClass(['list-item']),
          key: generateVueRenderKey(item.ID)
        }, [_createVNode(SearchResultItem, {
          listItem: item,
          listItemContent: item.getMessageContent(),
          type: _unref(currentSearchTabKey),
          displayType: generateResultItemDisplayType(),
          keywordList: _unref(keywordList),
          onShowResultDetail: showResultDetail,
          onNavigateToChatPosition: navigateToChatPosition
        }, null, 8, ["listItem", "listItemContent", "type", "displayType", "keywordList"])]);
      }), 128)) : (_openBlock(true), _createElementBlock(_Fragment, {
        key: 1
      }, _renderList(_unref(searchConversationResultGroupByDate), function (group) {
        return _openBlock(), _createElementBlock("div", {
          "class": _normalizeClass(['list-group', 'list-group-' + _unref(currentSearchTabKey)]),
          key: generateVueRenderKey(group.date)
        }, [_createElementVNode("div", _hoisted_15, _toDisplayString(group.date), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.list, function (item) {
          return _openBlock(), _createElementBlock("div", {
            "class": _normalizeClass(['list-group-item']),
            key: generateVueRenderKey(item.ID)
          }, [_createVNode(SearchResultItem, {
            listItem: item,
            listItemContent: item.getMessageContent(),
            type: _unref(currentSearchTabKey),
            displayType: generateResultItemDisplayType(),
            keywordList: _unref(keywordList),
            onShowResultDetail: showResultDetail,
            onNavigateToChatPosition: navigateToChatPosition
          }, null, 8, ["listItem", "listItemContent", "type", "displayType", "keywordList"])]);
        }), 128))], 2);
      }), 128)), _unref(searchConversationResult) && _unref(searchConversationResult).cursor ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        "class": "more",
        onClick: getMoreResultInConversation
      }, [_createVNode(Icon, {
        "class": "more-icon",
        file: _unref(searchIcon),
        width: "12px",
        height: "12px"
      }, null, 8, ["file"]), _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(TUITranslateService).t("TUISearch.查看更多历史记录")), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true)], 2));
    };
  }
});